<div class="row">
  <div class="col-12">
    <mat-form-field appearance="outline" [formGroup]="formGroup" *ngIf="!displayAccountForm">
      <mat-label>{{placeholderText}} search</mat-label>
      <input [matAutocomplete]="auto" matInput placeholder="{{placeholderText}} search" formControlName="company">

      <button type="button" color="primary" *ngIf="!loadingResults" mat-icon-button matSuffix (click)="searchPartyRoleSuite()">
        <mat-icon>search</mat-icon>
      </button>

      <mat-spinner matSuffix [diameter]="20" [strokeWidth]="3" *ngIf="loadingResults"></mat-spinner>

      <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayName">
        <mat-option (click)="addAccount()">+ Add a new {{placeholderText}}</mat-option>
        <mat-option *ngFor="let party of partyRolesSuites" [value]="party" (click)="selectCompany(party)">
          <span>{{ party.PartyName }}</span>
        </mat-option>
      </mat-autocomplete>
      <mat-error *ngIf="submitted && formGroup.get('company').hasError('required')">
        This field is required
      </mat-error>
    </mat-form-field>

  </div>
</div>

<div class="row" *ngIf="displayAccountForm">
  <div class="col-12">
    <p><strong>Create a new {{placeholderText}}</strong></p>
    <mat-form-field appearance="outline" [formGroup]="formGroup" *ngIf="displayAccountForm">
      <mat-label>Enter the company name</mat-label>
      <input matInput placeholder="Enter the company name" formControlName="accountName">
      <mat-error *ngIf="submitted && formGroup.get('accountName').hasError('required')">
        Please enter an company name
      </mat-error>
    </mat-form-field>
  </div>
</div>
<div class="row" *ngIf="displayPrimaryContacts && !displayAccountForm && !displayPrimaryForm">
  <div class="col-12">
    <mat-form-field appearance="outline" [formGroup]="formGroup">
      <mat-label>Contact</mat-label>
      <mat-select placeholder="Contact" formControlName="contact">
        <mat-option (click)="addContact()">+ Add a contact</mat-option>
        <mat-option *ngFor="let contact of contacts" [value]="contact" (click)="selectContact(contact)">{{contact.partyName}}</mat-option>
      </mat-select>
    </mat-form-field>
  </div>
  <div class="col-6" *ngIf="contactDetails.phone && contactDetails.phone.length > 0">
    <small>Phone<br/>
    <ng-container *ngFor="let phone of contactDetails.phone">
      {{phone?.TelephoneNumber?.telephoneNumber}}<br>
    </ng-container></small>
  </div>
  <div class="col-6" *ngIf="contactDetails.email && contactDetails.email.length > 0">
    <small>Email<br/>
    <ng-container *ngFor="let email of contactDetails.email">
        {{email?.EmailAddress?.emailAddress}}<br>
    </ng-container></small>
  </div>
  <div class="col-12" *ngIf="contactDetails.address && contactDetails.address.length > 0">
    <small>Address</small>
    <ng-container *ngFor="let address of contactDetails.address">
        {{address?.Address?.addressText}}<br>
    </ng-container>
  </div>

</div>

<ng-container *ngIf="displayPrimaryForm || displayAccountForm" [formGroup]="formGroup">
  <div class="row">
    <div class="col-12">
      <p><strong>Create company contact</strong></p>
    </div>
  </div>
  <div class="row">
    <div class="col-6">
      <mat-form-field appearance="outline">
        <input matInput placeholder="First name" formControlName="firstName">
        <mat-error *ngIf="submitted && formGroup.get('lastName').errors">
          Please enter a valid first name
        </mat-error>
      </mat-form-field>
    </div>
    <div class="col-6">
      <mat-form-field appearance="outline">
        <input matInput placeholder="Last name" formControlName="lastName">
        <mat-error *ngIf="submitted && formGroup.get('lastName').errors">
          Please enter a valid last name
        </mat-error>
      </mat-form-field>
    </div>
  </div>

  <div class="row">
    <div class="col-6">
       <fmc-sensis-mobile
        [parentFormGroup]="formGroup"
        [controlName]="'mobile'"
        [placeholderText]="'Phone'"
      ></fmc-sensis-mobile>
    </div>
    <div class="col-6">
      <fmc-sensis-email
        [parentFormGroup]="formGroup"
        [controlName]="'email'"
        [placeholderText]="'Email Address'"
        [centralisedValidation]="true"
      ></fmc-sensis-email>
    </div>
  </div>
</ng-container>

<div class="row" *ngIf="displayPrimaryForm || displayAccountForm">
  <div class="col-6">
    <button mat-raised-button type="button" (click)="resetForm()" cdkFocusInitial>Cancel</button>
  </div>
  <div class="col-6 text-end submit-actions">
    <mat-spinner matSuffix [diameter]="30"  *ngIf="loading" [strokeWidth]="3"></mat-spinner>
    <button mat-raised-button type="button" *ngIf="!loading" color="primary" (click)="createNewParty()" cdkFocusInitial>Submit</button>
  </div>
</div>
